import React from "react";
import { DefaultRecord } from "../types";
import { formateDate } from "../hook/ScreenHelper";
import { COLORS } from "../constants";

interface DefaultsSimahViewProps {
  data?: DefaultRecord[];
}

const DF_COLUMNS: {
  header: string;
  key: keyof DefaultRecord;
}[] = [
  { header: "DF_PRD", key: "productType" },
  { header: "DF_CAPL", key: "capitalCode" },
  { header: "DF_ACC_NO", key: "accountNumber" },
  { header: "DF_CRDTR", key: "creditorName" },
  { header: "DF_LOAD_DT", key: "loadedDate" },
  { header: "DF_ORIG_AMT", key: "originalAmount" },
  { header: "DF_CUB", key: "unpaidBalance" },
  { header: "DF_STAT", key: "status" },
  { header: "DF_SETTLD_DATE", key: "settledDate" },
];

const DF_DATE_COLUMNS: (keyof DefaultRecord)[] = [
  "loadedDate",
  "settledDate",
];

const DefaultsSimahView: React.FC<DefaultsSimahViewProps> = ({ data = [] }) => {
  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      <p
        className="text-dark m-0"
        style={{
          fontFamily: "Cairo",
          fontWeight: 500,
          fontSize: "20px",
        }}
      >
        Defaults
      </p>

      <table className="table text-center table-border spaced-table">
        {/* HEADER */}
        <thead style={{ background: "#F8F8F8" }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {DF_COLUMNS.map((col) => (
              <th key={col.header}>{col.header}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {data.map((row, i) => (
            <tr key={row.accountNumber ?? i}>
              {DF_COLUMNS.map((col) => {
                const value = row[col.key];
                const displayValue = DF_DATE_COLUMNS.includes(col.key)
                  ? formateDate(value)
                  : value;

                return (
                  <td key={col.header}>
                    {displayValue ?? "-"}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DefaultsSimahView;
